import { BATCH_TYPE_CREATE } from "src/constant";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import useProdGroups from "src/hooks/product-groups/useProdGroups";

export default function useInventoryTabs() {
  const { userMe } = useAuthGlobal();
  const permissionCheck = useRoleCheck();

  const warehouseType = userMe?.currentWarehouse?.type;
  const isFactory = warehouseType === BATCH_TYPE_CREATE.factory;
  const isNormal = warehouseType === BATCH_TYPE_CREATE.normal;

  const { data, isLoading } = useProdGroups({
    sortField: "order",
    sortOrder: "asc",
  });

  const tabs = [
    {
      id: "inventory",
      name: "Tồn kho",
    },
    ...(!isNormal && Array.isArray(data?.data)
      ? data.data.map((item) => ({
          ...item,
          display: permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) || isFactory,
        }))
      : []),
    {
      id: "expired-date",
      name: "Sản phẩm cận date",
      display: permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) || isFactory,
    },
  ];

  return { tabs, isLoading };
}
